@if (isDragging()) {
  <div class="dropzone-overlay" appDragAndDropFiles (fileDropped)="onFileDropped($any($event))">
    <div class="dropzone-content">
      <mat-icon>cloud_upload</mat-icon>
      <h3>Rilascia i file per caricarli...</h3>
    </div>
  </div>
}
